import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCardComponent } from '../product-card/product-card.component';
import { ProductRailSkeletonComponent } from '../product-rail-skeleton/product-rail-skeleton.component';

@Component({
  selector: 'app-product-rail',
  standalone: true,
  imports: [CommonModule, ProductCardComponent, ProductRailSkeletonComponent],
  templateUrl: './product-rail.component.html',
  styleUrls: ['./product-rail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRailComponent {
  /** Optional - shelves that render their own heading pass an empty title. */
  @Input() title = '';
  @Input() icon = 'fa-bag-shopping';
  @Input() products: any[] = [];
  @Input() loading = false;
  @Input() skeletonCount = 6;

  @ViewChild('scrollRow') scrollRow!: ElementRef<HTMLElement>;

  get skeletons(): unknown[] {
    return Array.from({ length: this.skeletonCount });
  }

  scroll(direction: 'left' | 'right'): void {
    const el = this.scrollRow?.nativeElement;
    if (!el) return;
    const amount = el.clientWidth * 0.8;
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
  }
}
